/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Toast_Upload_Error_DescInputs */

const es_settings_files_toast_upload_error_desc = /** @type {(inputs: Settings_Files_Toast_Upload_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron subir los archivos.`)
};

const en_settings_files_toast_upload_error_desc = /** @type {(inputs: Settings_Files_Toast_Upload_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not upload files.`)
};

/**
* | output |
* | --- |
* | "Could not upload files." |
*
* @param {Settings_Files_Toast_Upload_Error_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_upload_error_desc = /** @type {((inputs?: Settings_Files_Toast_Upload_Error_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Upload_Error_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_upload_error_desc(inputs)
	return en_settings_files_toast_upload_error_desc(inputs)
});
export { settings_files_toast_upload_error_desc as "settings.files.toast.upload_error_desc" }